import jwtDecode from "jwt-decode";

/** JWT / context role → "SüperAdmin" gibi boşluksuz tekil string */
export function normalizeAuthRole(role) {
 if (Array.isArray(role)) {
  role = role.find(Boolean) || "";
 }
 return String(role || "").replace(/\s+/g, "");
}

/** Kullanıcının tüm rollerini boşluksuz dizi olarak döner */
export function getAuthRoles(role) {
 if (Array.isArray(role)) {
  return role.map((item) => String(item || "").replace(/\s+/g, "")).filter(Boolean);
 }
 const single = normalizeAuthRole(role);
 return single ? [single] : [];
}

export function isAccessTokenExpired(token, skewMs = 30_000) {
 if (!token) return true;
 try {
  const { exp } = jwtDecode(token);
  if (!exp) return true;
  return exp * 1000 <= Date.now() + skewMs;
 } catch {
  return true;
 }
}

export function decodeAuthToken(token) {
 if (!token) return null;
 try {
  return jwtDecode(token);
 } catch {
  return null;
 }
}
